export default function initNewsModals() {
  const anchorTags = document.querySelectorAll('[data-open-modal]');

  // Loop through the anchor tags and attach click event listener to each
  anchorTags.forEach(anchorTag => {
    anchorTag.addEventListener('click', (event) => {
      event.preventDefault(); // prevent default link behavior
      const modalId = anchorTag.getAttribute('data-open-modal'); // get the value of data-open-modal attribute
      const lightBox = document.querySelector(`[data-modal-id="${modalId}"]`); // get the light-box element with matching data-modal-id attribute
      lightBox.classList.remove('hidden'); // remove "hidden" class to show the light-box
    });
  });

  const closeBtns = document.querySelectorAll('[data-close-modal]');

  closeBtns.forEach(closeBtn => {
    closeBtn.addEventListener('click', (event) => {
      event.preventDefault(); // prevent default link behavior
      const modalId = closeBtn.getAttribute('data-close-modal'); // get the value of data-close-modal attribute
      const lightBox = document.querySelector(`[data-modal-id="${modalId}"]`); // get the light-box element with matching data-modal-id attribute
      lightBox.classList.add('hidden'); // add "hidden" class to hide the light-box
    });
  });
}
